var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      staticClass: "supervised-person-manager-modal",
      attrs: { size: "tiny", closable: false },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c(
        "sui-modal-header",
        { staticClass: "supervised-person-manager-modal-header" },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
      _c(
        "sui-modal-content",
        [
          _c(
            "sui-form",
            [
              _c(
                "sui-form-field",
                [
                  _c("label", [_vm._v("Firm")]),
                  _c("sui-dropdown", {
                    attrs: {
                      selection: "",
                      search: "",
                      direction: "downward",
                      placeholder: "Search Firms...",
                      options: _vm.firmOptions,
                    },
                    model: {
                      value: _vm.firmFeeSchedule.firm,
                      callback: function ($$v) {
                        _vm.$set(_vm.firmFeeSchedule, "firm", $$v)
                      },
                      expression: "firmFeeSchedule.firm",
                    },
                  }),
                ],
                1
              ),
              _c(
                "sui-form-field",
                [
                  _c("label", [_vm._v("Fee Schedule")]),
                  _c("sui-dropdown", {
                    attrs: {
                      selection: "",
                      search: "",
                      direction: "downward",
                      placeholder: "Search Fee Schedules...",
                      options: _vm.feeSchedules,
                    },
                    model: {
                      value: _vm.firmFeeSchedule.fee_schedule,
                      callback: function ($$v) {
                        _vm.$set(_vm.firmFeeSchedule, "fee_schedule", $$v)
                      },
                      expression: "firmFeeSchedule.fee_schedule",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              size: "small",
              color: "grey",
              type: "button",
              content: "Cancel",
            },
            on: { click: _vm.cancel },
          }),
          _c("sui-button", {
            attrs: {
              primary: "",
              size: "small",
              type: "button",
              content: "Save",
            },
            on: { click: _vm.handleSave },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }